import { AloftDate, MainPropertyType, isDefined } from '@aloft/toolkit-shared';
import { Block, Flex } from '@aloft/toolkit-sui';

import { selectTotalEconomicLife } from '../../redux/features/selectors/depreciationSelectors.ts';
import {
  selectCostMultiplier,
  selectEffectiveDate,
} from '../../redux/features/selectors/orderSelectors.ts';
import { selectImprovementsById } from '../../redux/features/selectors/propertyDataSelectors/improvementsSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Typography } from '../../summary/components/Typography.tsx';

const CostApproachDataSourcesListItem = ({ text }: { text: string }) => (
  <Flex role="li" alignItems="center" gap=".25rem">
    <Block height=".25rem" width=".25rem" borderRadius="50%" backgroundColor="textSecondary" />
    <Typography variant="body2">{text}</Typography>
  </Flex>
);

export const CostApproachDataSources = ({
  propertyType,
}: {
  propertyType: MainPropertyType | undefined;
}) => {
  const qualityRating = useAppSelector((state) =>
    selectImprovementsById(state, 'subject'),
  )?.craftsmanQuality?.toFixed(1);

  const effectiveDateYear = AloftDate.schema.parse(useAppSelector(selectEffectiveDate)).getYear();

  const totalLife = useAppSelector((state) => selectTotalEconomicLife(state, 'subject'));
  const effectiveAge =
    useAppSelector((state) => selectImprovementsById(state, 'subject'))?.effectiveAge ?? 0;
  const remainingLife = (totalLife - effectiveAge).toFixed(0);
  const costMultiplier = useAppSelector(selectCostMultiplier);

  return (
    <Block role="ul" marginTop="1rem">
      <CostApproachDataSourcesListItem text="Source of cost data: Craftsman" />
      <CostApproachDataSourcesListItem
        text={`Effective date of cost data: 01/01/${effectiveDateYear ?? 'unknown'}`}
      />
      <CostApproachDataSourcesListItem
        text={`Quality rating from cost service: ${qualityRating ?? 'unknown'}`}
      />
      <CostApproachDataSourcesListItem
        text={`Est. remaining economic life: ${remainingLife} years`}
      />
      {propertyType !== 'manufacturedHome' && isDefined(costMultiplier) && (
        <CostApproachDataSourcesListItem
          text={`Additional cost multiplier of ${costMultiplier} was applied by the appraiser`}
        />
      )}
    </Block>
  );
};
